'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.matchItalic = exports.matchBold = exports.matchBlockquote = exports.matchList = exports.matchOrderedList = exports.matchHeading = undefined;

var _lodash = require('lodash');

var _markDownPatterns = require('./markDownPatterns');

var markDownPatterns = _interopRequireWildcard(_markDownPatterns);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var matchPattern = function matchPattern(pattern) {
    return function (text) {
        return text.match(pattern);
    };
};

// Block styles
var matchHeading = exports.matchHeading = matchPattern(markDownPatterns.HEADING);
var matchOrderedList = exports.matchOrderedList = matchPattern(markDownPatterns.ORDERED_LIST);
var matchList = exports.matchList = matchPattern(markDownPatterns.LIST);
var matchBlockquote = exports.matchBlockquote = matchPattern(markDownPatterns.BLOCKQUOTE);

var matchPatterns = function matchPatterns(patterns) {
    return function (text) {
        return patterns.reduce(function (currMatches, pattern) {
            var newMatch = null;
            var matches = [];
            do {
                newMatch = pattern.exec(text);
                if (newMatch) matches.push(newMatch);
            } while (newMatch);

            if ((0, _lodash.isEmpty)(matches)) return currMatches;

            return currMatches ? currMatches.concat(matches) : matches;
        }, null);
    };
};

// Inline styles
var matchBold = exports.matchBold = matchPatterns(markDownPatterns.BOLD);
var matchItalic = exports.matchItalic = matchPatterns(markDownPatterns.ITALIC);


//////////////////
// WEBPACK FOOTER
// ./src/client/components/editor/plugins/markdownSupport/markdownPatternMatcher.js
// module id = 1738
// module chunks = 0